import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import DatePickerRange, { DateRange } from 'components/Form/DatePickerRange'
import { CreationSchedule } from 'types/campaign'
import debounce from 'lodash/debounce'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store'
import service from '../service'

const DEBOUNCE_UPDATE_CREATION_DELAY = 200

const VoohCreationsFormSchedule: React.FC<{ readOnly: boolean }> = ({ readOnly }) => {
  const { t } = useTranslation()
  const { schedules, campaign, creationId } = useSelector(
    (state: RootState) => state.voohCreationEmission
  )

  const mappedCreationSchedules = useMemo(
    () => (schedules.dates ? service.creationSchedulesToDateRanges(schedules.dates) : []),
    [schedules.dates]
  )

  const debouncedChangeCreationSchedules = useCallback(
    debounce(service.handleChangeVoohCreationSchedules, DEBOUNCE_UPDATE_CREATION_DELAY),
    []
  )

  return (
    <div className='CreationsFormSchedule__calendar'>
      <DatePickerRange
        disabledDays={{
          from: new Date(Date.parse(campaign.startDate)),
          to: new Date(Date.parse(campaign.endDate)),
        }}
        values={mappedCreationSchedules}
        onChange={(dateRanges: DateRange[]) => {
          if (creationId && !readOnly && !schedules.loading) {
            debouncedChangeCreationSchedules(dateRanges, creationId, schedules.dates)
          }
        }}
        readOnly={readOnly || schedules.loading}
        loading={schedules.loading}
      />

      <div className='CreationsFormSchedule__list'>
        <div className='CreationsFormSchedule__list--header'>
          {t('form.campaign.creations.schedules.selectedDates')}:
        </div>

        {schedules.dates.map((creationSchedule: CreationSchedule<string>, i: number) => (
          <div
            key={i}
            className='CreationsFormSchedule__list--item'
          >
            {service.parseSchedule(creationSchedule)}
          </div>
        ))}
      </div>
    </div>
  )
}

export default VoohCreationsFormSchedule
